import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
var AmdNavbarItemComponent = /** @class */ (function () {
    /**
     * @param {?} changeDetectorRef
     */
    function AmdNavbarItemComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.navbarItemThemeClass = 'amd-navbar__item--default';
    }
    Object.defineProperty(AmdNavbarItemComponent.prototype, "theme", {
        /**
         * @param {?} theme
         * @return {?}
         */
        set: function (theme) {
            this.navbarItemThemeClass = "amd-navbar__item--" + theme;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    AmdNavbarItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-navbar-item',
                    template: "<div class=\"amd-navbar__item\" [ngClass]=\"navbarItemThemeClass\"> <ng-content></ng-content> </div>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdNavbarItemComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef, },
    ]; };
    AmdNavbarItemComponent.propDecorators = {
        'theme': [{ type: Input },],
    };
    return AmdNavbarItemComponent;
}());
export { AmdNavbarItemComponent };
function AmdNavbarItemComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarItemComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarItemComponent.ctorParameters;
    /** @type {?} */
    AmdNavbarItemComponent.propDecorators;
    /** @type {?} */
    AmdNavbarItemComponent.prototype.navbarItemThemeClass;
    /** @type {?} */
    AmdNavbarItemComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=navbar-item.component.js.map
//# sourceMappingURL=navbar-item.component.js.map
